import React, { useContext } from 'react'
import { Container, Title } from '@provi/provi-components'
import { TemplateContext } from '../../../components/template/context'
import { TemplateForm } from '../../../components/template-form'
import { FormFomik } from './form'

export const GraduationDate = () => {
  const { goToNextScreen, creditPath } = useContext(TemplateContext)
  return (
    <TemplateForm>
      <Container>
        <Title text="Qual o mês previsto de conclusão dos seus estudos?" />
        <FormFomik data={creditPath && creditPath.ReadExpectedGraduationDate} goToNextScreen={goToNextScreen} />
      </Container>
    </TemplateForm>
  )
}
